import { Container, makeStyles, Paper } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  recordHeader: {
    left: 0,
    overflow: "hidden",
    [theme.breakpoints.up("lg")]: {
      top: theme.layoutDimensions.recordHeaderTop,
      left: theme.layoutDimensions.mainDrawerWidth,
      height: theme.layoutDimensions.recordHeaderHeight,
      padding: 20,
      position: "fixed",
    },
    [theme.breakpoints.down("md")]: {
      padding: "25px 13px",
      marginLeft: "-25px",
      marginRight: "-24px",
      marginBottom: "5px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "42px 13px",
      marginLeft: "-25px",
      marginRight: "-24px",
      marginBottom: "5px",
    },
    right: 0,

    background: "#3f4f66",
    color: "#f5f5f5",

    // we want to appear on top the appbar so we can cover its border shadow
    //  on its bottom edge to give a clinical border between this and that
    //zIndex: theme.zIndex.appBar + 1,
    zIndex: 2, // need to speak to Joe about this find a way to reference the page
  },
  container: {
    padding: 0,
    margin: theme.layoutDimensions.mainDrawerWidth === 0 ? undefined : 0,
  },
}));

export const RecordHeader: React.FC = ({ children }) => {
  const classes = useStyles();
  return (
    // using `Paper` for a nice bottom border shadow
    <Paper className={classes.recordHeader} elevation={4} square>
      <Container maxWidth="xl" className={classes.container}>
        <>{children}</>
      </Container>
    </Paper>
  );
};
